import React, { useEffect, useState } from 'react';
import { maxDriverAgeDate, minDriverAgeDate } from 'Components/Constants';
import { Col } from 'reactstrap';
import TextField from '../../Components/FormGroup/TextField';
import SelectField from '../../Components/FormGroup/SelectField';
import DateField from '../../Components/FormGroup/DateField';
import { validateEmail, validateNINumber } from '../../Components/FormGroup/Validator';
import CheckBoxField from '../../Components/FormGroup/CheckBoxField';
import { noAccidentsOptions, titleOptions } from '../../Components/Constants';
import { Header, ResponsiveRow } from '../../Components/PageComponents';
import ReactGA from "react-ga4";
import { OptionsType } from 'Components/Types';
import { OptionsAPI } from 'API/GeneralAPI';

function MainDetailsForm() {

    const [isMainDriver, setIsMainDriver] = useState<boolean>(true);
    const [options, setOptions] = useState<OptionsType[]>([]);

    useEffect(() => {
        const getOptions = async () => {
            const response = await OptionsAPI.get("years_passed_test");
            const yearsPassedList = response.map((option: any) => {
                return { value: option["id"], desc: option["description"]};
            });
            setOptions(yearsPassedList);
        }
        getOptions();
    },[])
    
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    
    return (
        <>
            <Header>My Details</Header>
            <p>*If you will not be driving the motorhome, you will need to add an additional driver to your booking</p>
            <ResponsiveRow>
                <Col>
                    <SelectField name="title" label="Title" required={true} options={titleOptions} />
                </Col>
                <Col>
                    <TextField name="firstname" label="First Name" required={true} maxlength={35} />
                </Col>
            </ResponsiveRow>
            <ResponsiveRow>
                <Col>
                    <TextField name="lastname" label="Surname" required={true} maxlength={35} />
                </Col>
                <Col>
                    <DateField name="dob" label="Date of Birth" required={true} minDate={maxDriverAgeDate} maxDate={minDriverAgeDate} />
                </Col>
            </ResponsiveRow>
            <ResponsiveRow>
                <Col>
                    <TextField name="email" label="Email" validation={validateEmail} required={true} disabled={true}/>
                </Col>
                <Col>
                    <CheckBoxField name="main_driver_check" label="I will be driving the motorhome" defaultChecked={isMainDriver} onClick={() => setIsMainDriver(!isMainDriver)} />
                </Col>
            </ResponsiveRow>
            <ResponsiveRow>
                <Col>
                    <TextField name="staff_number" label="Staff Number" required={true} />
                </Col>
                <Col>
                    <TextField name="ni_number" label="NI Number" validation={validateNINumber} maxlength={9} required={true}/>
                </Col>
            </ResponsiveRow>
            {isMainDriver &&
                <ResponsiveRow>
                    <Col>
                        <SelectField name="years_passed_test" label="Driving Licence Held" options={options} required={true} removeValue="no licence"/>
                    </Col>
                    <Col>
                        <SelectField name="number_accidents" label="Number of Fault Accidents in the last 5 years" options={noAccidentsOptions} required={true}/>
                    </Col>
                </ResponsiveRow>
            }
        </>

    );
}
export default MainDetailsForm;
